import { useState, useEffect } from "react";
import ProjectPreview from "./ProjectPreview";
import classes from "./ProjectCollection.module.css";

function ProjectCollection(props) {
    const [selectedProject, setSelectedProject] = useState(props.data[0]);

    useEffect(() => {
        setSelectedProject(props.data[0]);
    }, [props.data]);

    return (
        <div className={classes.collection}>
            <div className={classes.previewList}>
                {props.data.map((project, i) => (
                    <ProjectPreview
                        key={i}
                        project={project}
                        onClick={() => setSelectedProject(project)}
                        isActive={project === selectedProject}
                    />
                ))}
            </div>
            <div className={classes.expandedView}>
                <props.expandedView project={selectedProject} />
            </div>
        </div>
    );
}

export default ProjectCollection;